import React, { useState, useEffect, memo } from "react";
import { Button } from "react-bootstrap";
import Pagination from "../../../../../../components/pagination/Pagination";
import TemplateTasksHeaderNew from "../template-tasks-header/TemplateTasksHeaderNew";
import TemplateTasksRowNew from "../template-tasks-row/TemplateTasksRowNew";
import { PulseLoader } from "react-spinners";
import { selectUser } from "../../../../../../redux/user/user-selector";
import {
  selectIsFetchingTemplateTasks,
  selectNumTemplateTasks,
  selectTemplateTasks,
  selectSelectedTemplateTasks,
  selectSearchTemplateTasksQuery,
} from "../../../../../../redux/templates-tasks/template-task-selector";
import { fetchTemplateTasks } from "../../../../../../redux/templates-tasks/template-task-actions";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "./template-tasks-container.scss";
import { GetTemplateTasksFiltersAPI } from "../../../../../../services/api/project-template-api";
import AdminActionsPopupNew from "../../../admin-actions-popup/AdminActionsPopupNew";
import PropTypes from "prop-types";

const TemplateTasksContainerNew = ({
  templateID,
  setAlertConfig,
  templateName,
}) => {
  const [showAdminActionsPopup, setShowAdminActionsPopup] = useState(false);
  const [filterList, setFilterList] = useState({});

  let history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const numEntries = useSelector(selectNumTemplateTasks);
  const data = useSelector(selectTemplateTasks);
  const selectedRows = useSelector(selectSelectedTemplateTasks);
  const searchQuery = useSelector(selectSearchTemplateTasksQuery);
  const loading = useSelector(selectIsFetchingTemplateTasks);

  useEffect(() => {
    const getFilters = async () => {
      const filters = await GetTemplateTasksFiltersAPI(templateID);
      setFilterList(filters.data);
    };

    refreshPage();
    getFilters();
  }, []);

  const refreshPage = () => {
    dispatch(
      fetchTemplateTasks({
        id: templateID,
        pageSize: 10,
        pageNumber: 1,
        sortDesc: false,
        sortBy: "Name",
        filters: [],
      })
    );
  };

  const changeData = (
    filters = searchQuery.filters,
    sortBy = searchQuery.sortBy,
    sortDesc = searchQuery.sortDesc
  ) => {
    dispatch(
      fetchTemplateTasks({
        ...searchQuery,
        filters: filters,
        sortBy: sortBy,
        sortDesc: sortDesc,
      })
    );
  };

  const nextPage = () => {
    dispatch(
      fetchTemplateTasks({
        ...searchQuery,
        pageNumber: searchQuery.pageNumber + 1,
      })
    );
  };

  const prevPage = () => {
    searchQuery.pageNumber >= 1 &&
      dispatch(
        fetchTemplateTasks({
          ...searchQuery,
          pageNumber: searchQuery.pageNumber - 1,
        })
      );
  };

  const rowChange = (numRows) => {
    dispatch(
      fetchTemplateTasks({ ...searchQuery, pageSize: numRows, pageNumber: 1 })
    );
  };

  const renderRows = () => {
    const Rows =
      data &&
      data.map((task) => {
        // Part of phasing out subtasks
        //const { SubTasks } = task;
        // no Subtasks
        //if (!(SubTasks && SubTasks.length))
        return (
          <TemplateTasksRowNew
            templateName={templateName}
            privileges={user?.privileges}
            key={data.assignID}
            data={task}
            templateID={templateID}
            hasSubtask={false}
            setAlertConfig={setAlertConfig}
            refreshPage={refreshPage}
            taskTypes={filterList[1]}
          />
        );
        // Part of phasing out subtasks
        // // at least 1 subtask
        // else {
        //   return (
        //     <>
        //       <TemplateTasksRowNew
        //         privileges={user?.privileges}
        //         key={data.assignID}
        //         data={task}
        //         templateID={templateID}
        //         hasSubtask={true}
        //         isSubtask={false}
        //         setAlertConfig={setAlertConfig}
        //         refreshPage={refreshPage}
        //         taskTypes={filterList[1]}
        //       />

        //       {task.subtaskOpen &&
        //         SubTasks.length !== 0 &&
        //         SubTasks.map((subtask) => {
        //           return (
        //             <TemplateTasksRowNew
        //               privileges={user?.privileges}
        //               key={subtask.assignID}
        //               data={subtask}
        //               templateID={templateID}
        //               hasSubtask={false}
        //               isSubtask={true}
        //               setAlertConfig={setAlertConfig}
        //               refreshPage={refreshPage}
        //               taskTypes={filterList[1]}
        //             />
        //           );
        //         })}
        //     </>
        //   );
        // }
      });
    return Rows;
  };

  const onTaskCreate = () => {
    if (!user?.privileges.Templates.Add === false) {
      history.push({
        pathname: "/admin/templates/tasks/create",
        state: { templateID: templateID, templateName: templateName },
      });
    }
  };

  const onDelete = () => {
    if (!user?.privileges.Templates.Delete === false) {
      setShowAdminActionsPopup(true);
    }
  };

  const getSelectedName = (taskId) => {
    if (!selectedRows || selectedRows.length <= 0) return "";

    const selectedRow = data.filter((task) => task.Id === taskId);

    return selectedRow[0].Name;
  };

  return (
    <div className="template-task-container">
      <div className="template-task-control-container">
        <div className="template-task-buttons-container">
          <Button
            className="action-btn-light create-task-btn"
            disabled={!user?.privileges.Templates.Add}
            onClick={onTaskCreate}
          >
            <div
              className={
                "btn-inner " +
                (user?.privileges.Templates.Add
                  ? "btn-inner-light-enabled"
                  : "btn-inner-light-disabled")
              }
            >
              Create New Task
            </div>
          </Button>

          <Button
            className="action-btn-light"
            onClick={(e) => {
              onDelete();
              e.preventDefault();
            }}
            disabled={!selectedRows.length}
          >
            <div
              className={
                "btn-inner " +
                (selectedRows.length > 0
                  ? "btn-inner-light-enabled"
                  : "btn-inner-light-disabled")
              }
            >
              <div
                className={
                  "icon-size " +
                  (selectedRows.length > 0
                    ? "archive-icon-white-enabled"
                    : "archive-icon-white-disabled")
                }
              ></div>
              Archive
            </div>
          </Button>
        </div>
        <div className="template-task-pagination">
          {!loading && (
            <Pagination
              refresh={refreshPage}
              next={nextPage}
              prev={prevPage}
              rowChange={rowChange}
              numEntries={numEntries}
              query={searchQuery}
            />
          )}
        </div>
      </div>

      {data && (
        <div className="table-main">
          <table className="table-element">
            <TemplateTasksHeaderNew
              changeData={changeData}
              refreshPage={refreshPage}
              templateID={templateID}
              tasks={filterList[0]}
              taskTypes={filterList[1]}
            />
            {!loading ? (
              <tbody>{renderRows()}</tbody>
            ) : (
              <div>
                <PulseLoader></PulseLoader>
              </div>
            )}
          </table>
        </div>
      )}

      {showAdminActionsPopup && (
        <AdminActionsPopupNew
          type={"task"}
          name={selectedRows.length === 1 && getSelectedName(selectedRows[0])}
          selectedIDs={selectedRows}
          showAdminActionsPopup={showAdminActionsPopup}
          setShowAdminActionsPopup={setShowAdminActionsPopup}
        />
      )}
    </div>
  );
};

TemplateTasksContainerNew.propTypes = {
  templateID: PropTypes.number.isRequired,
  setAlertConfig: PropTypes.func.isRequired,
  templateName: PropTypes.string.isRequired,
};

export default memo(TemplateTasksContainerNew);
